enum InputTypes{
  SSN,
  INCOME,
  VERIFICATION_CODE
}

export default InputTypes;
